import { createSlice } from "@reduxjs/toolkit";

export const ClientDataSlice = createSlice({
  name: "ClientDataReducer",
  initialState: {
    value: null,
  },
  reducers: {
    selectedClientData: (state, action) => {
      state.value = { ...state.value, ...action.payload};
    },
    clearClientData: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { selectedClientData, clearClientData } = ClientDataSlice.actions;

export default ClientDataSlice.reducer;
